<div id="loader" class="modal-bg" *ngIf="isLoading | async">
  <div class="lds-circle">
    <div>
      <img src="~/../assets/img/loader-img.png" alt="logo">
    </div>
  </div>
</div>
